import React, { FC, useMemo, useState } from 'react';
import FutureDevelopment from './FutureDevelopment';
import HistoricDevelopment from './HistoricDevelopment';
import useHistoricGraphData from './useHistoricGraphData';
import '../../../Arbeidsgiver.scss';
import '../../Storebrand.scss';
import './SavingProfileEstimates.scss';
import { SelectableProfile } from '../../../../../domain/Storebrand';

type EstimateModeOption = 'historic' | 'future';

type SavingProfilesEstimatesModal = {
    profiles: SelectableProfile[];
};
const SavingProfilesEstimatesModal: FC<SavingProfilesEstimatesModal> = ({ profiles }) => {
    const isins = useMemo(() => profiles.map((profile: { isin: any }) => profile.isin), [profiles]);

    // TODO: Uncomment when future development is greenlit - commented as requested in SPASP-7534
    // const estimateModeOptions = [
    //     { id: 'historic', name: 'Historisk' },
    //     { id: 'future', name: 'Fremtidig' }
    // ];

    const [estimateMode, _setEstimateMode] = useState<EstimateModeOption>('historic');

    const historicGraphData = useHistoricGraphData({ isins, profiles });

    // TODO: Uncomment when future development is greenlit - commented as requested in SPASP-7534
    const fundDevelopmentSwitch = null
        // (<TabList
        //     list={estimateModeOptions}
        //     click={(e: MouseEvent, _, item) => {
        //         e.preventDefault();
        //         setEstimateMode(item.id as EstimateModeOption);
        //     }}
        //     current={estimateMode}
        // />)


    return (
        <div className="estimates-wrapper">
            <h1 className="-title">Sammenligne spareprofilene</h1>
            {fundDevelopmentSwitch}
            {estimateMode === 'historic' && historicGraphData && <HistoricDevelopment graphData={historicGraphData} />}
            {estimateMode === 'future' && <FutureDevelopment />}
        </div>
    );
};

export default SavingProfilesEstimatesModal;
